import React, { Component } from 'react'
import SideMenu from '../admin/SideMenu';
import TopMenu from '../admin/TopBar';
import UploadImage from '../utils/UploadImage';
import '../../styles/css/AdminMain.css';
import swal from 'sweetalert2';
import RichTextMarkdown from "../utils/RichTextMarkdown";
import {PhotoshopPicker} from "react-color";
import {Modal} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const teams = [
    {teamId: 15, teamName: "Arizona Diamondbacks"},
    {teamId: 5295, teamName: "The Battery"},
    {teamId: 2, teamName: "Baltimore Orioles"},
    {teamId: 3, teamName: "Boston Red Sox"},
    {teamId: 17, teamName: "Chicago Cubs"},
    {teamId: 4, teamName: "Chicago White Sox"},
    {teamId: 2602, teamName: "Cincinnati Reds"},
    {teamId: 5, teamName: "Cleveland Indians"},
    {teamId: 19, teamName: "Colorado Rockies"},
    {teamId: 2394, teamName: "Detroit Tigers"},
    {teamId: 2392, teamName: "Houston Astros"},
    {teamId: 7, teamName: "Kansas City Royals"},
    {teamId: 1, teamName: "Los Angeles Angels"},
    {teamId: 22, teamName: "Los Angeles Dodgers"},
    {teamId: 4169, teamName: "Miami Marlins"},
    {teamId: 32, teamName: "Milwaukee Brewers"},
    {teamId: 3312, teamName: "Minnesota Twins"},
    {teamId: 3289, teamName: "New York Mets"},
    {teamId: 3313, teamName: "New York Yankees"},
    {teamId: 10, teamName: "Oakland Athletics"},
    {teamId: 2681, teamName: "Philadelphia Phillies"},
    {teamId: 31, teamName: "Pittsburgh Pirates"},
    {teamId: 2680, teamName: "San Diego Padres"},
    {teamId: 2395, teamName: "San Francisco Giants"},
    {teamId: 680, teamName: "Seattle Mariners"},
    {teamId: 2889, teamName: "St. Louis Cardinals"},
    {teamId: 12, teamName: "Tampa Bay Rays"},
    {teamId: 5370, teamName: "Texas Rangers"},
    {teamId: 14, teamName: "Toronto Blue Jays"},
    {teamId: 3309, teamName: "Washington Nationals"}
];

const applicationNames = [
    {value: 'MascotRace/1.0', name: 'MascotRace'},
    {value: 'Sqwad/1.0', name: 'Testing'},
    {value: 'HiddenBall/1.0', name: 'HiddenBall'},
    {value: 'Scratch&Win/1.0', name: 'Scratch&Win'},
    {value: 'JumpToSurvive/1.0', name: 'JumpToSurvive'}
];

class AdminHome extends Component {
    constructor(props) {
        super(props);
        this.UploadImage = new UploadImage();
        this.state = {
            emailVariables: {},
            loading:true,
            emailImagePreview: {},
            showTabOneMajor: true
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            loading: false
        })
    }

    componentWillUnmount() {
        URL.revokeObjectURL(this.state.emailImagePreview.preview);
    }

    openColorPicker(colorToChange){
        this.setState({
            colorPickerShow: true,
            colorToShow: this.state[colorToChange],
            colorToUpdate: colorToChange
        })
    }

    handleChange(event){
        let target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        if(target.type === 'checkbox' && (target.name === "advanced" || target.name === "isMlb")){
            this.setState({[target.name]: value})
        } else {
            let emailVariablesCopy = this.state.emailVariables;
            emailVariablesCopy[target.name] = value
            this.setState({ emailVariables:  emailVariablesCopy});
        }
    }

    handleImageChange(event){
        const name_of_file = event.target.name;
        const target = this[name_of_file];
        const file_to_update =target.files[0];
        this.setState({loading:true})
        const vm = this;
        this.UploadImage.upload_file(file_to_update).then(res => {
            vm.setState({loading:false})
            if(res.error){
                swal({
                    title: 'Image cannot be uploaded',
                    text: res.error,
                    type: 'warning',
                    confirmButtonText: 'Ok'
                })
            } else if(res.imageUrl) {
                let emailVariablesCopy = vm.state.emailVariables;
                emailVariablesCopy[name_of_file] = res.imageUrl
                vm.setState({
                    emailVariables: emailVariablesCopy,
                }, () => {
                    vm[name_of_file].value = ""
                });
            } else {
                swal({
                    title: 'Image cannot be uploaded',
                    text: "Something went wrong, please re-upload your image and try again!",
                    type: 'warning',
                    confirmButtonText: 'Ok'
                })
            }
        })
    }

    handleEmailChange (evt) {
        const target = evt.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ [evt.target.name]: value });
    }

    handleChangeComplete = (color) => {
        this.setState({
            colorToShow: color.hex
        })
    };

    acceptPicker(){
        const emailVariablesCopy = this.state.emailVariables;
        emailVariablesCopy[this.state.colorToUpdate] = this.state.colorToShow;
        this.setState({
            emailVariables: emailVariablesCopy,
            updateHappend: true,
            colorPickerShow: false,
        })
    }

    dismissPicker(){
        this.setState({
            colorPickerShow: false,
        })
    }

    handleRichTextChange = (name, text) => {
        let copy = this.state.emailVariables || {};
        copy[name] = text;
        this.setState({ emailVariables:  copy});
    }

    splitStringIntoArray(array){
        if(!array) return [];
        const splitOnLineBreaks = array.split("\n");
        let splitOnWhiteSpace = array.split(/\s+/);
        let splitOnCommas = array.split(",");
        let splitArray = splitOnLineBreaks;
        if(splitOnWhiteSpace.length === splitOnCommas.length){
            splitOnWhiteSpace = array.replace(/,/g, '').split(/\s+/);
            splitOnCommas = array.replace(/\s/g,'').split(",");
        }
        if(splitArray.length < splitOnWhiteSpace.length){
            splitArray = splitOnWhiteSpace
        }
        if(splitArray.length < splitOnCommas.length){
            splitArray = splitOnCommas
        }
        return splitArray
    }

    async sendEmail(updateRulesObject){
        const emails = this.splitStringIntoArray(this.state.emailInput);
        if(!emails || emails.length === 0) {
            alert("No emails Entered!");
            this.setState({loading: false})
            return;
        }
        const codesArray = this.splitStringIntoArray(this.state.codesArray);
        if(codesArray && codesArray.length > 0 && emails.length !== codesArray.length){
            alert("Emails does not equal; " + codesArray.length + " does not equal " + emails.length);
            this.setState({loading: false})
            return;
        }
        let url = `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/api/sendEmails`;
        if(process.env.NODE_ENV === "development"){
            url = `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/us-central1/api/sendEmails`;
        }
        this.setState({loading: true})
        const bearerToken = await this.props.user.getIdToken();
        const bearerTokenString = "Bearer " + bearerToken;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': bearerTokenString
            },
            body: JSON.stringify({
                emails: emails,
                emailVariables: updateRulesObject,
                showEmailMessage: this.state.showTabOneMajor,
                codes: codesArray
            }),
        });
        this.setState({loading: false})
        console.log(response)
        if (response.ok) {
            alert('Successfully Sent!')
        } else {
            console.log(await response.json())
            alert('Error Sending!')
        }
    }

    async handleSubmit(event) {
        event.preventDefault();
        const emailVariables = this.state.emailVariables;
        let sender = emailVariables.sender || "";
        let subjectLine = emailVariables.subjectLine || "";
        let preview = emailVariables.previewText || "";
        let imageLink = emailVariables.imageLink || "";
        let emailHeaderImage = emailVariables.emailHeaderImage || "";
        let prizeImage = emailVariables.prizeImage || "";
        let showButton = emailVariables.showButton || "";
        let showQrCode = emailVariables.showQrCode || false;
        let descriptionText = emailVariables.descriptionText || "";
        let showButtonText = emailVariables.showButtonText || "";
        let showButtonColor = emailVariables.showButtonColor || "";
        let showButtonTextColor = emailVariables.showButtonTextColor || "";
        let expiresAtDateTime = emailVariables.expiresAtDateTime || "";
        let expiresAtHours = emailVariables.expiresAtHours || "";
        let mlbButtonText = emailVariables.mlbButtonText || "";
        let mlbMessageTeamId = emailVariables.mlbMessageTeamId || "";
        let vendorName = emailVariables.vendorName || "";
        let templateText = emailVariables.templateText || "";
        let mlbPrizeImage = emailVariables.mlbPrizeImage || "";
        let applicationName = emailVariables.applicationName || "";
        let rewardName = emailVariables.rewardName || "";
        let projectId = emailVariables.projectId || "";
        if(expiresAtDateTime && typeof expiresAtDateTime === 'object'){
            expiresAtDateTime = expiresAtDateTime.getTime();
        }
        if(descriptionText === "<p><br></p>"){
            descriptionText = "";
        } else {
            descriptionText = descriptionText.toString('html')
        }
        this.setState({loading:true});
        const updateRulesObject = {};
        updateRulesObject['descriptionText'] = descriptionText;
        updateRulesObject['subjectLine'] = subjectLine;
        updateRulesObject['sender'] = sender;
        updateRulesObject['imageLink'] = imageLink;
        updateRulesObject['headerImage'] = emailHeaderImage;
        updateRulesObject['prizeImage'] = prizeImage;
        updateRulesObject['previewText'] = preview;
        updateRulesObject['showButton'] = showButton;
        updateRulesObject['showButtonText'] = showButtonText;
        updateRulesObject['showButtonTextColor'] = showButtonTextColor;
        updateRulesObject['showButtonColor'] = showButtonColor;
        updateRulesObject['expiresAtDateTime'] = expiresAtDateTime;
        updateRulesObject['mlbId'] = mlbMessageTeamId;
        updateRulesObject['templateText'] = templateText;
        updateRulesObject['vendorName'] = vendorName;
        updateRulesObject['mlbButtonText'] = mlbButtonText;
        updateRulesObject['mlbPrizeImage'] = mlbPrizeImage;
        updateRulesObject['expiresAtHours'] = expiresAtHours;
        updateRulesObject['applicationName'] = applicationName;
        updateRulesObject['projectId'] = projectId;
        updateRulesObject['rewardName'] = rewardName;
        updateRulesObject['showQrCode'] = showQrCode;
        if(this.state.showTabTwoMajor && (!applicationName || !vendorName || !subjectLine || !projectId || !mlbPrizeImage)){
            this.setState({loading:false});
            alert("Not all necessary MLB variables are inputted")
            return;
        } else if(this.state.showTabTwoMajor && vendorName.length > 50){
            this.setState({loading:false});
            alert("The vendor name is too long, make sure it is 50 characters or less")
            return;
        } else if(this.state.showTabTwoMajor && templateText.length > 300){
            this.setState({loading:false});
            alert("The template text is too long, make sure it is 300 characters or less")
            return;
        }

        try {
            await this.sendEmail(updateRulesObject)
        } catch (e) {
            this.setState({loading:false})
            await swal({
                title: 'There was some error!',
                text: 'Try again and if the problem persists try logging out and logging back in',
                type: 'error',
                confirmButtonText: 'Ok'
            })
        }
    }

    tripleToggleControl(element, whichToggle){
        const tabOne = "showTabOne" + whichToggle;
        const tabTwo = "showTabTwo" + whichToggle;
        const tabThree = "showTabThree" + whichToggle;
        const firstElement = document.getElementById('showfirst' + whichToggle);
        const secondElement = document.getElementById('showsecond' + whichToggle);
        const thirdElement = document.getElementById('showthird' + whichToggle);
        if(element === "first"){
            firstElement.classList.add('active');
            secondElement.classList.remove('active');
            if(thirdElement){
                thirdElement.classList.remove('active');
            }
            this.setState({
                [tabOne]: true,
                [tabTwo]: false,
                [tabThree]: false,
            })
        }else if(element === "second"){
            firstElement.classList.remove('active');
            secondElement.classList.add('active');
            if(thirdElement){
                thirdElement.classList.remove('active');
            }
            this.setState({
                [tabOne]: false,
                [tabTwo]: true,
                [tabThree]: false,
            })
        } else {
            firstElement.classList.remove('active');
            secondElement.classList.remove('active');
            if(thirdElement){
                thirdElement.classList.add('active');
            }
            this.setState({
                [tabOne]: false,
                [tabTwo]: false,
                [tabThree]: true,
            })
        }
    }

    render() {
        let sender = this.state.emailVariables.sender || "";
        let subjectLine = this.state.emailVariables.subjectLine || "";
        let mlbMessageTeamId = this.state.emailVariables.mlbMessageTeamId || "";
        let vendorName = this.state.emailVariables.vendorName || "";
        let showQrCode = this.state.emailVariables.showQrCode || "";
        let mlbButtonText = this.state.emailVariables.mlbButtonText || "";
        let templateText = this.state.emailVariables.templateText || "";
        let preview = this.state.emailVariables.previewText || "";
        let descriptionText = this.state.emailVariables.descriptionText || "";
        let showButton = this.state.emailVariables.showButton || false;
        let showButtonText = this.state.emailVariables.showButtonText || "";
        let showButtonTextColor = this.state.emailVariables.showButtonTextColor;
        let showButtonColor = this.state.emailVariables.showButtonColor;
        let applicationName = this.state.emailVariables.applicationName;
        let rewardName = this.state.emailVariables.rewardName;
        let projectId = this.state.emailVariables.projectId;
        let imageLink = this.state.emailVariables.imageLink || "";
        let emailHeaderImage = this.state.emailVariables.emailHeaderImage || "";
        let mlbPrizeImage = this.state.emailVariables.mlbPrizeImage || "";
        let prizeImage = this.state.emailVariables.prizeImage || "";
        let expiresAtDateTime = this.state.emailVariables.expiresAtDateTime;
        if(!expiresAtDateTime){
            expiresAtDateTime = null;
        }
        return (
            <div className="admin-wrapper">
                <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
                <SideMenu/>
                <TopMenu/>
                <div className="admin-main-panel">
                    <p className="admin-header-text" style={{marginBottom:0}}>Send Email Branding</p>
                    <p className="admin-subheader-text">This is where you can edit your follow up communication sent to fans</p>
                    {/*<p className="admin-subheader-text">Lee-MLBID: 00u5db61yaFmp0GWx357</p>*/}
                    <div className="container">
                        <div className="admin-form-box">
                            <form onSubmit={this.handleSubmit} id="create-email-form">
                                <button className="btn btn-primary btn-lg update-button" id="submitButton" style={{marginBottom:10}}><span className="fa fa-arrow-circle-o-up"/> Send</button>
                                {/*<div className="mb-3 form-check">*/}
                                {/*    <input className="form-check-input" type="checkbox" checked={this.state.isMlb} id="isMlb" name="isMlb" onChange={this.handleChange}/>*/}
                                {/*    <label htmlFor="isMlb" className="form-check-label">Is MLB Team</label>*/}
                                {/*</div>*/}
                                <div className="form-group">
                                    <textarea
                                        className="form-control"
                                        value={this.state.emailInput}
                                        onChange={this.handleEmailChange}
                                        placeholder={this.state.showTabTwoMajor ? "Enter Okta ID" : "Enter Email"}
                                        name="emailInput"
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="codesArray" className="col-md-3 col-form-label">Enter Codes (1234,1238,1230) OPTIONAL</label>
                                    <textarea value={this.state.codesArray} className="form-control" name="codesArray" onChange={this.handleEmailChange} placeholder="1235,1238,1230"/>
                                </div>
                                {this.state.codesArray && this.state.codesArray.length > 0 &&
                                    <div className="mb-3 form-check">
                                        <input className="form-check-input" type="checkbox" checked={showQrCode} id="showQrCode" name="showQrCode" onChange={this.handleChange}/>
                                        <label htmlFor="showQrCode" className="form-check-label">Show QR Code</label>
                                    </div>
                                }
                                <div className="mb-3">
                                    <label htmlFor="subjectLine" className="form-label">Subject Line</label>
                                    <div className="form-text">This is the subject line that your fans will see when they receive their messages</div>
                                    <input id="subjectLine" name="subjectLine" className="form-control" value={subjectLine} onChange={this.handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="rewardName" className="form-label">Prize Name (Optional)</label>
                                    <div className="form-text">This is the name of the reward that will show up in the email/message</div>
                                    <input id="rewardName" name="rewardName" className="form-control" value={rewardName} onChange={this.handleChange} />
                                </div>
                                <ul className="nav nav-tabs nav-justified nav-bordered mb-3">
                                    <li className="nav-item" onClick={()=> this.tripleToggleControl('first', 'Major')}>
                                        <a href="#" aria-expanded="false" className="nav-link active" id="showfirstMajor">
                                            <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                            <span className="d-none d-lg-block">Email</span>
                                        </a>
                                    </li>
                                    <li className="nav-item" onClick={()=> this.tripleToggleControl('second', 'Major')}>
                                        <a href="#" aria-expanded="true" className="nav-link" id="showsecondMajor">
                                            <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                            <span className="d-none d-lg-block">MLB Prize Message</span>
                                        </a>
                                    </li>
                                    {/*<li className="nav-item" onClick={()=> this.tripleToggleControl('third', 'Major')}>*/}
                                    {/*    <a href="#" aria-expanded="true" className="nav-link" id="showthirdMajor">*/}
                                    {/*        <i className="mdi mdi-account-circle d-lg-none d-block mr-1"/>*/}
                                    {/*        <span className="d-none d-lg-block">MLB Prize Message</span>*/}
                                    {/*    </a>*/}
                                    {/*</li>*/}
                                </ul>
                                <div style={{display: this.state.showTabOneMajor ? 'block' : 'none'}}>
                                    <div className="mb-3">
                                        <label htmlFor="previewText" className="form-label">Preview Text</label>
                                        <div className="form-text">This is the preview text for the email, if left blank it will be replaced by the subject line. For mobile optimization the length should be between 35-50 characters but for desktop the preview can be up to 140 characters and beyond</div>
                                        <input id="previewText" name="previewText" className="form-control" value={preview} onChange={this.handleChange}/>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="descriptionText" className="form-label">Description Text</label>
                                        <div className="form-text">This is where you can tell fans where to contact you with issues. (Example: Having issues? Email info@help.com for help.)</div>
                                        <RichTextMarkdown
                                            allowParagraphAlignment={true}
                                            allowButtons={true}
                                            field={{
                                                id: "descriptionText",
                                                name: "descriptionText",
                                                value: descriptionText
                                            }}
                                            form={{
                                                setFieldValue: (field, text) => this.handleRichTextChange("descriptionText", text)
                                            }}
                                            label="Prize Description"
                                            sublabel="Describe the prize that the user will receive."
                                            placeholder="My Sweet Prize Description"
                                        />
                                        {/*<RichTextEditor toolbarConfig={toolbarConfig} style={{minHeight: '100px'}} id="descriptionText" name="descriptionText" value={descriptionText} onChange={(text) => this.handleRichTextChange("descriptionText", text)}/>*/}
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="imageLink" className="form-label">Image Link</label>
                                        <div className="form-text">This link, if filled in, will be accessible by clicking the Follow Up Image</div>
                                        <input id="imageLink" name="imageLink" className="form-control" value={imageLink} onChange={this.handleChange}/>
                                    </div>
                                    <div className="mb-3" align="center">
                                        <img src={emailHeaderImage} width="auto" height="100px" alt=""/>
                                        <br/>
                                        <label htmlFor="emailHeaderImage" className="form-label">Email Header Image<br/>(700px X 400px)</label>
                                        <div className="mb-3">
                                            <input style={{display:'none'}}  id="emailHeaderImage" name="emailHeaderImage" type="file" ref={input => {this.emailHeaderImage = input; }} onChange={this.handleImageChange}/>
                                            <input className='btn btn-primary btn-lg choose-image-button' type="button" value="Choose Image" onClick={() => document.getElementById('emailHeaderImage').click()} />
                                        </div>
                                    </div>
                                    <div className="mb-3" align="center">
                                        <img src={prizeImage} width="auto" height="100px" alt=""/>
                                        <br/>
                                        <label htmlFor="prizeImage" className="form-label">Prize Image<br/>(700px X 400px)</label>
                                        <div className="mb-3">
                                            <input style={{display:'none'}}  id="prizeImage" name="prizeImage" type="file" ref={input => {this.prizeImage = input; }} onChange={this.handleImageChange}/>
                                            <input className='btn btn-primary btn-lg choose-image-button' type="button" value="Choose Image" onClick={() => document.getElementById('prizeImage').click()} />
                                        </div>
                                    </div>
                                    <div className="mb-3 form-check">
                                        <input className="form-check-input" type="checkbox" checked={showButton} id="showButton" name="showButton" onChange={this.handleChange}/>
                                        <label htmlFor="showButton" className="form-check-label">Show Button</label>
                                    </div>
                                    {showButton &&
                                        <>
                                            <div className="form-group">
                                                <label htmlFor="showButtonText">Button Text</label>
                                                <input id="showButtonText" name="showButtonText" type="text" className="form-control" value={showButtonText} onChange={this.handleChange} placeholder={"See Prize!"}/>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-inline">
                                              <span style={{marginRight: 10}}
                                                    className="fa fa-eyedropper mobile-hide"
                                                    onClick={() => this.openColorPicker("showButtonTextColor")}/>
                                                        <div style={{
                                                            backgroundColor: showButtonTextColor,
                                                            marginRight: 10,
                                                            border: "solid 1px",
                                                            minHeight: 20,
                                                            width: 20,
                                                            display: "inline-block"
                                                        }}/>
                                                        <label htmlFor="showButtonTextColor" style={{marginRight: 10}}>Button Text Color</label>
                                                        <input id="showButtonTextColor" name="showButtonTextColor"
                                                               type="text" className="form-control"
                                                               value={showButtonTextColor}
                                                               onChange={this.handleChange} placeholder="#000"/>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-inline">
                                              <span style={{marginRight: 10}}
                                                    className="fa fa-eyedropper mobile-hide"
                                                    onClick={() => this.openColorPicker("showButtonColor")}/>
                                                        <div style={{
                                                            backgroundColor: showButtonColor,
                                                            marginRight: 10,
                                                            border: "solid 1px",
                                                            minHeight: 20,
                                                            width: 20,
                                                            display: "inline-block"
                                                        }}/>
                                                        <label htmlFor="showButtonColor" style={{marginRight: 10}}>Button Color</label>
                                                        <input id="showButtonColor" name="showButtonColor"
                                                               type="text" className="form-control"
                                                               value={showButtonColor}
                                                               onChange={this.handleChange} placeholder="#000"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                                <div style={{display: this.state.showTabTwoMajor ? 'block' : 'none'}}>
                                    <div className="mb-3">
                                        <label htmlFor="mlbMessageTeamId" className="form-label">Team Id</label>
                                        <div className="form-text">Team Id That Impacts The Branding</div>
                                        <select id="mlbMessageTeamId" name="mlbMessageTeamId" className="form-control" value={mlbMessageTeamId} onChange={this.handleChange}>
                                            <option value="">Select team</option>
                                            {teams.map(team =>
                                                <option key={team.teamId} value={team.teamId}>{team.teamName}</option>
                                            )}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="applicationName" className="form-label">Application Name</label>
                                        <div className="form-text">Just for MLB API purposes</div>
                                        <select id="applicationName" name="applicationName" className="form-control" value={applicationName} onChange={this.handleChange}>
                                            <option value="">Select Application Name</option>
                                            {applicationNames.map(applicationName =>
                                                <option key={applicationName.value} value={applicationName.value}>{applicationName.name}</option>
                                            )}
                                        </select>
                                        {/*<input id="applicationName" name="applicationName" className="form-control" value={applicationName} onChange={this.handleChange}/>*/}
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="projectId" className="form-label">Tenant URL</label>
                                        <div className="form-text">Necessary for link to open. Ex: https://hidden-ball-demo.web.app</div>
                                        <input id="projectId" name="projectId" className="form-control" value={projectId} onChange={this.handleChange}/>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="vendorName" className="form-label">Vendor Name</label>
                                        <div className="form-text">Shows up in the message</div>
                                        <input id="vendorName" name="vendorName" className="form-control" value={vendorName} onChange={this.handleChange}/>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="mlbButtonText" className="form-label">Button Text</label>
                                        <div className="form-text">Shows up in the message</div>
                                        <input id="mlbButtonText" name="mlbButtonText" className="form-control" value={mlbButtonText} onChange={this.handleChange}/>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="templateText" className="form-label">Template Text</label>
                                        <div className="form-text">Shows up in the message</div>
                                        <input id="templateText" name="templateText" className="form-control" value={templateText} onChange={this.handleChange}/>
                                    </div>
                                    <div className="mb-3" align="center">
                                        <img src={mlbPrizeImage} width="auto" height="100px" alt=""/>
                                        <br/>
                                        <label htmlFor="mlbPrizeImage" className="form-label">MLB Prize Image<br/>(700px X 400px)</label>
                                        <div className="mb-3">
                                            <input style={{display:'none'}}  id="mlbPrizeImage" name="mlbPrizeImage" type="file" ref={input => {this.mlbPrizeImage = input; }} onChange={this.handleImageChange}/>
                                            <input className='btn btn-primary btn-lg choose-image-button' type="button" value="Choose Image" onClick={() => document.getElementById('mlbPrizeImage').click()} />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="advanced">Advanced</label>
                                        <br/>
                                        <input type="checkbox" checked={this.state.advanced} id="advanced" name="advanced" onChange={this.handleChange}/>
                                    </div>
                                    {this.state.advanced &&
                                        <>
                                            <div className="form-group">
                                                <label htmlFor="expiresAtHours">Hours Until Expire</label>
                                                <input id="expiresAtHours" name="expiresAtHours" step="1" type="number" className="form-control" value={this.state.emailVariables.expiresAtHours} onChange={this.handleChange} placeholder="720"/>
                                            </div>
                                            OR/AND
                                            <div className="form-group row mb-3 form_times">
                                                <label className="col-md-3 col-form-label" htmlFor="expiresAtDateTime"> Date Until Expire</label>
                                                <div className="col-md-9">
                                                    <DatePicker
                                                        showTimeInput
                                                        dateFormat="Pp"
                                                        selected={this.state.emailVariables.expiresAtDateTime}
                                                        onChange={date => this.setState(prevState => ({
                                                            emailVariables: {
                                                                ...prevState.emailVariables,
                                                                expiresAtDateTime: date
                                                            }
                                                        }))}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                                {this.state.showTabOneMajor &&
                                    <>
                                        <div className="mb-3 form-check">
                                            <input className="form-check-input" type="checkbox" checked={this.state.advanced} id="advanced" name="advanced" onChange={this.handleChange}/>
                                            <label htmlFor="showAdvancedSettings" className="form-check-label">Advanced</label>
                                        </div>
                                        {this.state.advanced &&
                                            <>
                                                <div className="mb-3">
                                                    <label htmlFor="sender" className="form-label">Email Sender</label>
                                                    <div className="form-text">This is the sender your fans will see when they receive their winning emails. BE AWARE: changing the sender could adversely impact delivery rates</div>
                                                    <input id="sender" name="sender" type="email" className="form-control" value={sender} onChange={this.handleChange} />
                                                </div>
                                            </>
                                        }
                                    </>
                                }
                            </form>
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.colorPickerShow} toggle={this.state.colorPickerShow} id="myModal">
                    <PhotoshopPicker onChangeComplete={ this.handleChangeComplete } color={this.state.colorToShow} onAccept={()=>this.acceptPicker()} onCancel={()=> this.dismissPicker()}/>
                </Modal>
            </div>
        );
    }
}

export default AdminHome
